module.exports = __webpack_public_path__ + "0d427a802321e21908592d40297bc006.svg";